import { FormattedMessage } from 'react-intl';
import React from 'react';
import { ACL } from './constants/UogACL/ACL';
import { DOCUMENTS_ACL } from './constants/PackageGroupACL/DOCUMENT_ACL';
import momentTimezone from 'moment-timezone';
import { FEATURE_PRODUCT_CERTIFICATE_WITH_AUTH } from './features';

export { ACL, DOCUMENTS_ACL };

export const DEFAULT_USER_GROUP_NAME = "Users";
export const DEFAULT_ADMIN_GROUP_NAME = "Admin";
export const DEFAULT_ADMIN_USER_GROUP_NAME = "super-admin";

export const SINGLE_DOCUMENT_SIGNATURE_FLOW = {
  documents: [
    DOCUMENTS_ACL.CREATE_DOCUMENTS,
    DOCUMENTS_ACL.UPDATE_DOCUMENTS,
    DOCUMENTS_ACL.LIST_DOCUMENTS,
    DOCUMENTS_ACL.READ_DOCUMENTS,
  ],
};

export const INVITATION_STATUSES = {
  PENDING: 0,
  REJECTED: 1,
  ACCEPTED: 2
};

// NO_PAGINATION is used when we use a get call without pagination, but the call has pagination
export const NO_PAGINATION = {
  page: 1,
  per_page: 100000
}

export const PACKAGE_STATUSES = {
  DRAFT: 0,
  PENDING: 1,
  FINISHED: 2,
  REJECTED: 3,
  REVOKED: 4,
  EXPIRED: 5,
  FAILED: 6,
  SENDING: 7,
  ERROR_ON_CONNECTIVE: 8,
  ERROR_ON_INFOCERT: 9,
  ARCHIVING: 10,
  ARCHIVED: 11,
  DELETE_IN_PROGRESS: 12,
};

export const BATCH_SIGNING_FLOW_STATUSES = {
  DRAFT: 0,
  FAILED: 1,
  PENDING: 2,
  FINISHED: 3,
  REVOKED: 4,
};

export const SIGNATURE_TRACKING = {
  READY: 0,
  PENDING: 1,
  USED: 2,
};

export const REFUND_ERROR_CODES = {
  REFUND_FAILED: 'BT_REFUND_10001',
};

let message = [];
message[PACKAGE_STATUSES.DRAFT] =
  <FormattedMessage id="messages.draft_status"/>;
message[PACKAGE_STATUSES.PENDING] =
  <FormattedMessage id="messages.pending_status"/>;
message[PACKAGE_STATUSES.SENDING] =
  <FormattedMessage id="messages.pending_status"/>;
message[PACKAGE_STATUSES.ERROR_ON_CONNECTIVE] =
  <FormattedMessage id="messages.pending_status"/>;
message[PACKAGE_STATUSES.FINISHED] =
  <FormattedMessage id="messages.finished_status"/>;
message[PACKAGE_STATUSES.REJECTED] =
  <FormattedMessage id="messages.rejected_status"/>;
message[PACKAGE_STATUSES.REVOKED] =
  <FormattedMessage id="messages.revoked_status"/>;
message[PACKAGE_STATUSES.EXPIRED] =
  <FormattedMessage id="messages.expired_status"/>;
message[PACKAGE_STATUSES.FAILED] =
  <FormattedMessage id="messages.failed_status"/>;
message[PACKAGE_STATUSES.DELETE_IN_PROGRESS] =
  <FormattedMessage id="status.package_delete_in_progress"/>;

export const PACKAGE_STATUS_MESSAGES = message;

export const LIBRA_PAY_AUTH_URL = process.env.REACT_APP_LIBRA_PAY_AUTH_URL

export const USER_STATUSES = {
  DEACTIVATED: 0,
  ACTIVE: 1,
  DELETE_INITIATED: 2,
  DELETE_IN_PROGRESS: 3,
  DELETE_FINISHED: 4,
  INACTIVE: 5,// When user has not verified his email, this is used only in FE for the moment
}

export const USER_DELETE_STATUSES = [
  USER_STATUSES.DELETE_INITIATED,
  USER_STATUSES.DELETE_IN_PROGRESS,
  USER_STATUSES.DELETE_FINISHED
]

export const TRANSLATED_USER_STATUSES = {
  [USER_STATUSES.DEACTIVATED]: <FormattedMessage id="status.user_deactivated"/>,
  [USER_STATUSES.ACTIVE]: <FormattedMessage id="status.user_active"/>,
  [USER_STATUSES.DELETE_INITIATED]: <FormattedMessage
    id="status.user_delete_initiated"/>,
  [USER_STATUSES.DELETE_IN_PROGRESS]: <FormattedMessage
    id="status.user_delete_in_progress"/>,
  [USER_STATUSES.DELETE_FINISHED]: <FormattedMessage
    id="status.user_delete_finished"/>,
  [USER_STATUSES.INACTIVE]: <FormattedMessage id="status.user_inactive"/>,
}

export const ORDER_STATUSES = {
  INITIATED: 0,
  PAID: 1,
  PAYMENT_ERROR: 2,
  REFUNDED_INITIATED: 3,
  REFUND_CONFIRMED: 4,
  REFUND_ERROR: 5,
  REFUNDED_SUCCESS: 6,
  CANCELLED_BY_ADMIN: 7,
  CANCELLED_BY_USER: 8,
}

export const TRANSLATED_ORDER_STATUSES = {
  [ORDER_STATUSES.INITIATED]: <FormattedMessage id="status.order.initiated"/>,
  [ORDER_STATUSES.PAID]: <FormattedMessage id="status.order.paid"/>,
  [ORDER_STATUSES.PAYMENT_ERROR]: <FormattedMessage id="status.order.payment_error"/>,
  [ORDER_STATUSES.REFUNDED_INITIATED]:<FormattedMessage id="status.order.refund_initiated"/>,
  [ORDER_STATUSES.REFUND_CONFIRMED]:<FormattedMessage id="status.order.refund_confirmed"/>,
  [ORDER_STATUSES.REFUND_ERROR]:<FormattedMessage id="status.order.refund_error"/>,
  [ORDER_STATUSES.REFUNDED_SUCCESS]:<FormattedMessage id="status.order.refund_success"/>,
  [ORDER_STATUSES.CANCELLED_BY_ADMIN]:<FormattedMessage id="status.order.cancelled"/>,
  [ORDER_STATUSES.CANCELLED_BY_USER]:<FormattedMessage id="status.order.cancelled"/>,
}

const CERTIFICATE_STATUSES = {
  NOT_ASSIGNED : 0,
  ASSIGNED : 1,
  GENERATED : 2,
  REVOKED : 3,
  REFUND_INITIATED : 4,
  REFUND_CONFIRMED : 5,
  REFUND_SUCCESS : 6,
  EXPIRED : 7,
  ACTIVATING_IN_PROGRESS : 8,
}

export const TRANSLATED_CERTIFICATE_FILTER_STATUSES = {
  [CERTIFICATE_STATUSES.NOT_ASSIGNED] : <FormattedMessage id="certificate_statuses.not_assigned" />,
  [CERTIFICATE_STATUSES.ASSIGNED] : <FormattedMessage id="certificate_statuses.assigned" />,
  [CERTIFICATE_STATUSES.GENERATED] : <FormattedMessage id="certificate_statuses.generated" />,
  [CERTIFICATE_STATUSES.REVOKED] : <FormattedMessage id="certificate_statuses.revoked" />,
  [CERTIFICATE_STATUSES.REFUND_INITIATED] : <FormattedMessage id="certificate_statuses.refund_initiated" />,
  [CERTIFICATE_STATUSES.REFUND_CONFIRMED] : <FormattedMessage id="certificate_statuses.refund_confirmed" />,
  [CERTIFICATE_STATUSES.REFUND_SUCCESS] : <FormattedMessage id="certificate_statuses.refund_success" />,
  [CERTIFICATE_STATUSES.EXPIRED] : <FormattedMessage id="certificate_statuses.expired" />,
}

export const TRANSLATED_CERTIFICATE_STATUSES = {
  ...TRANSLATED_CERTIFICATE_FILTER_STATUSES,
  [CERTIFICATE_STATUSES.ACTIVATING_IN_PROGRESS] : <FormattedMessage id="certificate_statuses.assigned" />,
}

export const GOOGLE_SITEKEY = process.env.REACT_APP_GOOGLE_SITEKEY;

export const RESPONSIVE = {
  DESKTOP: '1420',
  TABLET: '1024',
  MTABLET: '768',
  MOBILE: '400'
}

export const VAT = 0.21;

export const TRANSLATED_PACKAGE_STATUSES = {
  [PACKAGE_STATUSES.DRAFT]: <FormattedMessage id="status.package_draft"/>,
  [PACKAGE_STATUSES.PENDING]: <FormattedMessage id="status.package_pending"/>,
  [PACKAGE_STATUSES.FINISHED]: <FormattedMessage id="status.package_finished"/>,
  [PACKAGE_STATUSES.REJECTED]: <FormattedMessage id="status.package_rejected"/>,
  [PACKAGE_STATUSES.REVOKED]: <FormattedMessage id="status.package_revoked"/>,
  [PACKAGE_STATUSES.EXPIRED]: <FormattedMessage id="status.package_expired"/>,
  [PACKAGE_STATUSES.FAILED]: <FormattedMessage id="status.package_failed"/>,
  [PACKAGE_STATUSES.SENDING]: <FormattedMessage id="status.package_sending"/>,
  [PACKAGE_STATUSES.ERROR_ON_CONNECTIVE]: <FormattedMessage id="status.package_error"/>,
  [PACKAGE_STATUSES.ERROR_ON_INFOCERT]: <FormattedMessage id="status.package_error"/>,
  [PACKAGE_STATUSES.ARCHIVING]: <FormattedMessage id="status.package_archiving"/>,
  [PACKAGE_STATUSES.ARCHIVED]: <FormattedMessage id="status.package_archived"/>,
  [PACKAGE_STATUSES.DELETE_IN_PROGRESS]: <FormattedMessage id="status.package_delete_in_progress"/>,
}

export const PRODUCT_GROUPS = {
  SIMPLE_SIGNATURE: {
    name: 'simple-signatures',
    text: <FormattedMessage
      id="components.pages.orderManagement.selectProductGroup.simple_signatures"/>,
    active: true,
  },
  CERTIFICATE: {
    name: 'certificates',
    text: <FormattedMessage
      id="components.pages.orderManagement.selectProductGroup.certificates"/>,
    active: true,
  },
  CERTIFICATE_WITH_AUTH: {
    name: 'certificates-with-auth',
    text: <FormattedMessage
      id="components.pages.orderManagement.selectProductGroup.certificates_with_auth"/>,
    active: FEATURE_PRODUCT_CERTIFICATE_WITH_AUTH,
  },
  QUALIFIED_SIGNATURE: {
    name: 'qualified-signatures',
    text: <FormattedMessage
      id="components.pages.orderManagement.selectProductGroup.qualified_signatures"/>,
    active: true,
  },
}

export const PRODUCT_NAMES = {
  STARTER: 'starter',
  STANDARD: 'standard',
  ADVANCED: 'advanced',
  CUSTOM_ORDER: 'custom-order',
}

export const TICKETS_STATUSES = {
  NEW: 0,
  APPROVED: 1,
  IN_PROGRESS: 2,
  WAITING_RESPONSE: 3,
  SOLVED: 4,
  REJECTED: 5,
  ERROR_ON_JOB: 6,
}

export const TRANSLATED_TICKETS_STATUSES = {
  [TICKETS_STATUSES.NEW]: <FormattedMessage id="statuses.tickets.new"/>,
  [TICKETS_STATUSES.APPROVED]: <FormattedMessage id="statuses.tickets.approved"/>,
  [TICKETS_STATUSES.IN_PROGRESS]: <FormattedMessage id="statuses.tickets.in_progress"/>,
  [TICKETS_STATUSES.WAITING_RESPONSE]: <FormattedMessage
    id="statuses.tickets.waiting_response"/>,
  [TICKETS_STATUSES.SOLVED]: <FormattedMessage
    id="statuses.tickets.solved"/>,
  [TICKETS_STATUSES.REJECTED]: <FormattedMessage
    id="statuses.tickets.rejected"/>,
  [TICKETS_STATUSES.ERROR_ON_JOB]: <FormattedMessage
    id="statuses.tickets.error_on_process"/>,
}

export const TICKET_SUBJECTS = {
  DELETE_ORGANIZATION: 0,
  CONTACT_ISSUES: 1,
  CONTACT_COMMERCIAL: 2,
  CONTACT_OTHERS: 3,
  NEO_IMPORT_CLIENT : 4,
  NEO_IMPORT_ORDER : 5,
  NEO_IMPORT_RECEIPT : 6,
  CLONE_PACKAGE: 7,
  PACKAGE_EMAIL_NOTIFICATION: 8,
  INFOCERT_CERTIFICATE_DETAILS: 9,
}

export const TRANSLATED_TICKETS_SUBJECTS = {
  [TICKET_SUBJECTS.DELETE_ORGANIZATION]: <FormattedMessage id="subjects.tickets.delete_organization"/>,
  [TICKET_SUBJECTS.CONTACT_ISSUES]: <FormattedMessage id={"components.pages.ticket.table.table_row.type.problems"}/>,
  [TICKET_SUBJECTS.CONTACT_COMMERCIAL]: <FormattedMessage id={"components.pages.ticket.table.table_row.type.commercial"}/>,
  [TICKET_SUBJECTS.CONTACT_OTHERS]: <FormattedMessage id={"components.pages.ticket.table.table_row.type.others"}/>,
  [TICKET_SUBJECTS.NEO_IMPORT_CLIENT]: <FormattedMessage id={"components.pages.ticket.table.table_row.type.neo_import_client"}/>,
  [TICKET_SUBJECTS.NEO_IMPORT_ORDER]: <FormattedMessage id={"components.pages.ticket.table.table_row.type.neo_import_order"}/>,
  [TICKET_SUBJECTS.NEO_IMPORT_RECEIPT]: <FormattedMessage id={"components.pages.ticket.table.table_row.type.neo_import_receipt"}/>,
  [TICKET_SUBJECTS.CLONE_PACKAGE]: <FormattedMessage id={"components.pages.ticket.table.table_row.type.clone_package"}/>,
  [TICKET_SUBJECTS.PACKAGE_EMAIL_NOTIFICATION]: <FormattedMessage id={"components.pages.ticket.table.table_row.type.package_email_notification"}/>,
  [TICKET_SUBJECTS.INFOCERT_CERTIFICATE_DETAILS]: <FormattedMessage id={"components.pages.ticket.table.table_row.type.infocert_certificate_details"}/>,
}

export const TICKET_TYPES = {
  DELETE_ORGANIZATION: 0,
  CONTACT_ISSUES: 1,
  CONTACT_COMMERCIAL: 2,
  CONTACT_OTHERS: 3,
  NEO_IMPORT_CLIENT : 4,
  NEO_IMPORT_ORDER : 5,
  NEO_IMPORT_RECEIPT : 6,
  CLONE_PACKAGE: 7,
  PACKAGE_EMAIL_NOTIFICATION: 8,
  TECHNICAL: 9,
}

export const TRANSLATED_TICKET_TYPES = {
  [TICKET_TYPES.DELETE_ORGANIZATION]: <FormattedMessage id="components.pages.ticket.table.table_row.type.delete"/>,
  [TICKET_TYPES.CONTACT_ISSUES]: <FormattedMessage id="components.pages.ticket.table.table_row.type.problems"/>,
  [TICKET_TYPES.CONTACT_COMMERCIAL]: <FormattedMessage id="components.pages.ticket.table.table_row.type.commercial"/>,
  [TICKET_TYPES.CONTACT_OTHERS]: <FormattedMessage id="components.pages.ticket.table.table_row.type.others"/>,
  [TICKET_TYPES.NEO_IMPORT_CLIENT]: <FormattedMessage id={"components.pages.ticket.table.table_row.type.neo_import_client"}/>,
  [TICKET_TYPES.NEO_IMPORT_ORDER]: <FormattedMessage id={"components.pages.ticket.table.table_row.type.neo_import_order"}/>,
  [TICKET_TYPES.NEO_IMPORT_RECEIPT]: <FormattedMessage id={"components.pages.ticket.table.table_row.type.neo_import_receipt"}/>,
  [TICKET_TYPES.CLONE_PACKAGE]: <FormattedMessage id={"components.pages.ticket.table.table_row.type.clone_package"}/>,
  [TICKET_TYPES.PACKAGE_EMAIL_NOTIFICATION]: <FormattedMessage id={"components.pages.ticket.table.table_row.type.package_email_notification"}/>,
  [TICKET_TYPES.TECHNICAL]: <FormattedMessage id={"components.pages.ticket.table.table_row.type.technical"}/>,
}

export const PAGE_CONTEXTS = {
  DOCUMENTS: {
    LIST: 'documents-list',
    VIEW: 'documents-view',
  },
  ADMIN_USER: {
    LIST: 'admin-user-list',
    VIEW: 'admin-user-view',
  },
  ADMIN_GROUP: {
    LIST: 'admin-group-list',
  },
  CLIENT_USER: {
    LIST: 'client-user-list',
    VIEW: 'client-user-view',
  },
  ORDERS: {
    LIST: 'list-orders',
    VIEW: 'view-orders',
    CREATE_CUSTOM: 'create-custom-orders',
  },
  TICKETS: {
    LIST: 'list-tickets',
  },
  APPOINTMENTS: {
    LIST: 'list-appointments',
  },
  CAMPAIGNS: {
    LIST: 'list-campaigns',
  },
  CLIENT_ORGANIZATION: {
    VIEW: 'client-organization-view',
    LIST: 'client-organization-list',
  },
  CERTIFICATES: {
    LIST: 'certificates-list',
  },
}

export const CUSTOM_EMAIL_TEMPLATES = {
  CONTACT_AFTER_REGISTER: {
    label: <FormattedMessage id={"components.pages.clients.forms.contact_after_register"}/>,
    value: 'contact-after-register',
  }
}

export const ORDER_TYPES = {
  BILLABLE: {
    value: 0,
    label: <FormattedMessage id={"fields.order_billable"}/>,
  },
  DIRECT_ALLOCATION: {
    value: 1,
    label: <FormattedMessage id={"fields.order_direct_allocation"}/>,
  },
}

const getRomaniaTimeForUTCOffset = () => {
  if (process.env.NODE_ENV === 'test') {
    return momentTimezone.tz('2021-01-01T00:00:00.000Z', 'Europe/Bucharest');
  }

  return momentTimezone.tz('Europe/Bucharest');
}

export const romaniaUTCOffset = getRomaniaTimeForUTCOffset().format('Z');

export const getLocalHourOnRomaniaTimeZone = (date, dateWithoutHours) => {
  momentTimezone.tz.setDefault( 'Europe/Bucharest' );
  let romaniaTime = '';

  if (dateWithoutHours) {
    romaniaTime = momentTimezone.tz( date, "Europe/Bucharest" ).format( 'DD.MM.YYYY' );

    return romaniaTime;
  }

  romaniaTime = momentTimezone.tz( date, "Europe/Bucharest" ).format( 'HH:mm' );

  romaniaTime = romaniaTime + ` UTC${romaniaUTCOffset}`;

  return romaniaTime;
}

export const TABLE_CONTEXTS = {
  DOCUMENTS: 'documents',
  ADMIN_USERS: 'admin-users',
  ADMIN_GROUPS: 'admin-groups',
  CLIENT_USERS: 'client-users',
  ORDERS: 'orders',
  TICKETS: 'tickets',
  APPOINTMENTS: 'appointments',
  CAMPAIGNS: 'campaigns',
}

export const TABLE_SEARCHES_TYPES = {
  FILTERS: 'filters',
  SEARCH_TEXT: 'search-text',
  ROWS_PER_PAGE: 'rows-per-page',
  SORT_FIELD: 'sort-field',
  SORT_DIRECTION: 'sort-direction',
  META: 'meta',
}

export const FILTER_TYPES = {
  'RADIO': 'radio',
  'CHECKBOX': 'checkbox',
  'DATE': 'date',
};

export const DEFAULT_RADIO_FILTER_ALL_VALUE = "all";

export const ORGANIZATION_STATUSES = {
  CREATED: 0,
  DELETE_INITIATED: 1,
  DELETE_IN_PROGRESS: 2,
  DELETE_FINISHED: 3,
}

export const ORGANIZATION_DELETE_STATUSES = [
  ORGANIZATION_STATUSES.DELETE_INITIATED,
  ORGANIZATION_STATUSES.DELETE_IN_PROGRESS,
  ORGANIZATION_STATUSES.DELETE_FINISHED,
]

export const TRANSLATED_ORGANIZATION_STATUSES = {
  [ORGANIZATION_STATUSES.CREATED]: <FormattedMessage id="status.organization_created"/>,
  [ORGANIZATION_STATUSES.DELETE_INITIATED]: <FormattedMessage id="status.organization_delete_initiated"/>,
  [ORGANIZATION_STATUSES.DELETE_IN_PROGRESS]: <FormattedMessage id="status.organization_delete_in_progress"/>,
  [ORGANIZATION_STATUSES.DELETE_FINISHED]: <FormattedMessage id="status.organization_delete_finished"/>,
}

export const API_KEY_STATUSES = {
  DISABLED: 0,
  ENABLED: 1,
}

export const TRANSLATED_API_KEY_STATUSES = {
  [API_KEY_STATUSES.DISABLED]: <FormattedMessage id="status.api_key_disabled"/>,
  [API_KEY_STATUSES.ENABLED]: <FormattedMessage id="status.api_key_enabled"/>,
}

export const ARCHIVE_SERVICE_STATUSES = {
  DISABLED: 0,
  ENABLED: 1,
  PENDING: 2,
  BILLABLE: 3,
  DISABLED_BY_MYSIGN_ADMIN: 4,
}

export const TRANSLATED_ARCHIVE_SERVICE_STATUSES = {
  [ARCHIVE_SERVICE_STATUSES.DISABLED]: <FormattedMessage id="status.archive_service_disabled"/>,
  [ARCHIVE_SERVICE_STATUSES.ENABLED]: <FormattedMessage id="status.archive_service_enabled"/>,
  [ARCHIVE_SERVICE_STATUSES.PENDING]: <FormattedMessage id="status.archive_service_pending"/>,
  [ARCHIVE_SERVICE_STATUSES.BILLABLE]: <FormattedMessage id="status.archive_service_billable"/>,
  [ARCHIVE_SERVICE_STATUSES.DISABLED_BY_MYSIGN_ADMIN]: <FormattedMessage id="status.archive_service_disabled_by_mysign_admin"/>,
}

export const ARCHIVE_SERVICE_DELETED_STATUSES = [
  ARCHIVE_SERVICE_STATUSES.DISABLED,
  ARCHIVE_SERVICE_STATUSES.DISABLED_BY_MYSIGN_ADMIN,
]

export const KIOSK_ACCESS_STATUSES = {
  DISABLED: 0,
  ENABLED: 1,
}

export const TRANSLATED_KIOSK_ACCESS_STATUSES = {
  [KIOSK_ACCESS_STATUSES.DISABLED]: <FormattedMessage id="status.kiosk_access_disabled"/>,
  [KIOSK_ACCESS_STATUSES.ENABLED]: <FormattedMessage id="status.kiosk_access_enabled"/>,
}

export const SIGNING_TYPES = {
  SIMPLE: 0,
  QUALIFIED: 1,
}

export const TRANSLATED_SIGNING_TYPES = {
  [SIGNING_TYPES.SIMPLE]: <FormattedMessage id="status.signing_type_simple"/>,
  [SIGNING_TYPES.QUALIFIED]: <FormattedMessage id="status.signing_type_qualified"/>,
}

export const BITWARDEN_ERROR_TITLES_MESSAGES = {
  'The operation was aborted. ': "bitwarden.passkey_operation_cancelled_by_client",
  'The request is not allowed by the user agent or the platform in the current context, possibly because the user denied permission.': "bitwarden.passkey_operation_cancelled_by_client",
  'The operation either timed out or was not allowed.': "bitwarden.passkey_operation_cancelled_by_client",
  'The operation either timed out or was not allowed. See: https://www.w3.org/TR/webauthn-2/#sctn-privacy-considerations-client.': "bitwarden.passkey_operation_cancelled_by_client",
}

export const EMAIL_CAMPAIGN_TEMPLATES_TYPES = {
  TERMS_AND_POLICY_UPDATE: 1,
}

export const EMAIL_CAMPAIGN_TEMPLATES = {
  TERMS_AND_POLICY_UPDATE: {
    label: <FormattedMessage id={"components.pages.emailCampaigns.createEmailCampaign.createEmailCampaignForm.terms_and_policy_update"}/>,
    value: EMAIL_CAMPAIGN_TEMPLATES_TYPES.TERMS_AND_POLICY_UPDATE,
  }
}

export const EMAIL_CAMPAIGN_RECIPIENTS_TYPES = {
  TEST_USERS: 1,
  ACCEPTED_TERMS_AND_CONDITIONS_USERS: 2,
  SELECTED_USERS: 3,
}

export const EMAIL_CAMPAIGN_RECIPIENTS = {
  TEST_USERS: {
    label: <FormattedMessage id={"components.pages.emailCampaigns.createEmailCampaign.createEmailCampaignForm.test_users"}/>,
    value: EMAIL_CAMPAIGN_RECIPIENTS_TYPES.TEST_USERS,
  },
  ACCEPTED_TERMS_AND_CONDITIONS_USERS: {
    label: <FormattedMessage id={"components.pages.emailCampaigns.createEmailCampaign.createEmailCampaignForm.accepted_terms_and_conditions_users"}/>,
    value: EMAIL_CAMPAIGN_RECIPIENTS_TYPES.ACCEPTED_TERMS_AND_CONDITIONS_USERS,
  },
  SELECTED_USERS: {
    label: <FormattedMessage id={"components.pages.emailCampaigns.createEmailCampaign.createEmailCampaignForm.selected_user_emails"}/>,
    value: EMAIL_CAMPAIGN_RECIPIENTS_TYPES.SELECTED_USERS,
  },
}

export const EMAIL_CAMPAIGN_STATUSES = {
  CREATED: 0,
  SENT: 1,
}

export const TRANSLATED_EMAIL_CAMPAIGN_STATUSES = {
  [EMAIL_CAMPAIGN_STATUSES.CREATED]: <FormattedMessage id="status.email_campaign_created"/>,
  [EMAIL_CAMPAIGN_STATUSES.SENT]: <FormattedMessage id="status.email_campaign_sent"/>,
}

export const TRANSLATED_EMAIL_CAMPAIGN_TEMPLATES = {
  [EMAIL_CAMPAIGN_TEMPLATES_TYPES.TERMS_AND_POLICY_UPDATE]: EMAIL_CAMPAIGN_TEMPLATES.TERMS_AND_POLICY_UPDATE.label,
}

export const TRANSLATED_EMAIL_CAMPAIGN_RECIPIENTS = {
  [EMAIL_CAMPAIGN_RECIPIENTS_TYPES.TEST_USERS]: EMAIL_CAMPAIGN_RECIPIENTS.TEST_USERS.label,
  [EMAIL_CAMPAIGN_RECIPIENTS_TYPES.ACCEPTED_TERMS_AND_CONDITIONS_USERS]: EMAIL_CAMPAIGN_RECIPIENTS.ACCEPTED_TERMS_AND_CONDITIONS_USERS.label,
  [EMAIL_CAMPAIGN_RECIPIENTS_TYPES.SELECTED_USERS]: EMAIL_CAMPAIGN_RECIPIENTS.SELECTED_USERS.label,
}

export const TICKET_PRODUCT_REFERENCES = {
  CERTIFICATES: 0,
  CERTIFICATES_WITH_AUTH: 1,
  QUALIFIED_SIGNATURES: 2,
  SIMPLE_SIGNATURES: 3,
  OTHERS: 4,
}

export const TRANSLATED_TICKET_PRODUCT_REFERENCES = {
  [TICKET_PRODUCT_REFERENCES.CERTIFICATES]: <FormattedMessage id="components.pages.ticket.table.table_row.product_references.certificates"/>,
  [TICKET_PRODUCT_REFERENCES.CERTIFICATES_WITH_AUTH]: <FormattedMessage id="components.pages.ticket.table.table_row.product_references.certificates_with_auth"/>,
  [TICKET_PRODUCT_REFERENCES.QUALIFIED_SIGNATURES]: <FormattedMessage id="components.pages.ticket.table.table_row.product_references.qualified_signatures"/>,
  [TICKET_PRODUCT_REFERENCES.SIMPLE_SIGNATURES]: <FormattedMessage id="components.pages.ticket.table.table_row.product_references.simple_signatures"/>,
  [TICKET_PRODUCT_REFERENCES.OTHERS]: <FormattedMessage id={"components.pages.ticket.table.table_row.product_references.others"}/>,
}

export const CERTIFICATE_USAGE_TYPES = {
  SIGNATURE: 0,
  AUTHENTICATION: 1,
}
